// Environment configuration utility
// Handles both development (process.env) and production (window._env_) environments

const getEnvVar = (key, fallback = '') => {
  // In production/containerized environments, use window._env_
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  
  // In development, fall back to process.env
  if (process.env[key] !== undefined) {
    return process.env[key];
  }
  
  // Return fallback if neither is available
  return fallback;
};

// Export environment variables with fallback logic
export const ENV_CONFIG = {
  NODE_ENV: getEnvVar('NODE_ENV', 'development'),
  REACT_APP_PORT: getEnvVar('REACT_APP_PORT', '8880'),
  REACT_APP_URL: getEnvVar('REACT_APP_URL', 'https://kbauth.mykowri.com/auth'),
  REACT_APP_REALM: getEnvVar('REACT_APP_REALM', 'Billbox'),
  REACT_APP_CLIENT: getEnvVar('REACT_APP_CLIENT', 'billbox-bulk'),
  REACT_APP_ALLOWED_ORIGINS: getEnvVar('REACT_APP_ALLOWED_ORIGINS', 'http://localhost:3000'),
  REACT_APP_DEFAULT_ORIGIN: getEnvVar('REACT_APP_DEFAULT_ORIGIN', 'http://localhost:3000'),
  REACT_APP_BILLBOX_BASE_URL: getEnvVar('REACT_APP_BILLBOX_BASE_URL', 'https://business.mykowri.com'),
  REACT_APP_BULK_PROCESSOR_BASE_URL: getEnvVar('REACT_APP_BULK_PROCESSOR_BASE_URL', 'https://kbbulkprocessor.mykowri.com'),
  REACT_APP_NEW_APP_PROD_URL: getEnvVar('REACT_APP_NEW_APP_PROD_URL', 'https://b.kowri.app'),
  REACT_APP_NEW_APP_NON_PROD_URL: getEnvVar('REACT_APP_NEW_APP_NON_PROD_URL', 'https://payments.mykowri.com/v1'),
  REACT_APP_SHOW_NEW_APP_CTA: getEnvVar('REACT_APP_SHOW_NEW_APP_CTA', 'true'),
  REACT_APP_MIDDLEWARE_URL: getEnvVar('REACT_APP_MIDDLEWARE_URL', 'http://localhost:8880'),
  REACT_APP_LOGENTRIES_TOKEN: getEnvVar('REACT_APP_LOGENTRIES_TOKEN', ''),
  REACT_APP_BULK_FILE_GENERATOR_URL: getEnvVar('REACT_APP_BULK_FILE_GENERATOR_URL', ''),
  REACT_APP_BULK_FILE_GENERATOR_ALT: getEnvVar('REACT_APP_BULK_FILE_GENERATOR_ALT', ''),
  REACT_APP_BULK_BENEFICIARY_GENERATOR_FILE_URL: getEnvVar('REACT_APP_BULK_BENEFICIARY_GENERATOR_FILE_URL', ''),
  REACT_APP_BULK_TRANSFER_FILE_GENERATOR_URL: getEnvVar('REACT_APP_BULK_TRANSFER_FILE_GENERATOR_URL', ''),
  REACT_APP_BULK_FILE_INSTITUTION_CODE_URL: getEnvVar('REACT_APP_BULK_FILE_INSTITUTION_CODE_URL', '/Institution-Codes-List.xlsx'),
  REACT_APP_KOWRI_BANK_NAME: getEnvVar('REACT_APP_KOWRI_BANK_NAME', 'Fidelity Bank'),
  REACT_APP_KOWRI_BANK_ACCOUNT_NAME: getEnvVar('REACT_APP_KOWRI_BANK_ACCOUNT_NAME', 'SEVN Ghana Ltd'),
  REACT_APP_KOWRI_BANK_BRANCH: getEnvVar('REACT_APP_KOWRI_BANK_BRANCH', 'Ridge Towers'),
  REACT_APP_KOWRI_BANK_ACCOUNT_NUMBER: getEnvVar('REACT_APP_KOWRI_BANK_ACCOUNT_NUMBER', '1070001234576'),
  REACT_APP_KOWRI_BANK_SORT_CODE: getEnvVar('REACT_APP_KOWRI_BANK_SORT_CODE', '130100'),
  REACT_APP_PAYJACK_BANK_ACCOUNT_NAME: getEnvVar('REACT_APP_PAYJACK_BANK_ACCOUNT_NAME', "OrangeTech's Settlement/Collections"),
  REACT_APP_PAYJACK_BANK_BRANCH: getEnvVar('REACT_APP_PAYJACK_BANK_BRANCH', 'Ridge'),
  REACT_APP_PAYJACK_BANK_ACCOUNT_NUMBER: getEnvVar('REACT_APP_PAYJACK_BANK_ACCOUNT_NUMBER', '1300034019710'),
  REACT_APP_BILLBOX_HOME: getEnvVar('REACT_APP_BILLBOX_HOME', 'http://localhost:8080/billbox'),
  REACT_APP_KOWRI_CDN: getEnvVar('REACT_APP_KOWRI_CDN', 'https://d4lubfpts333i.cloudfront.net'),
  REACT_APP_BULK_PROCESSOR_PUBLIC_URL: getEnvVar('REACT_APP_BULK_PROCESSOR_PUBLIC_URL', 'https://kbbulkprocessor.mykowri.com'),
  REACT_APP_ORIGIN_KOWRI: getEnvVar('REACT_APP_ORIGIN_KOWRI', 'https://payments.mykowri.com'),
  REACT_APP_BATCH_PROCESSING_POLLING_INTERVAL: getEnvVar('REACT_APP_BATCH_PROCESSING_POLLING_INTERVAL', '10000'),
  PUBLIC_URL: getEnvVar('PUBLIC_URL', ''),
  REACT_APP_DEFAULT_MIN_PAYMENT_AMOUNT: getEnvVar('REACT_APP_DEFAULT_MIN_PAYMENT_AMOUNT', '0.01'),
  REACT_APP_DEFAULT_MAX_PAYMENT_AMOUNT: getEnvVar('REACT_APP_DEFAULT_MAX_PAYMENT_AMOUNT', '999999999'),
};

export default ENV_CONFIG;
